/* USERS */
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"

/* USERS DETAIL*/
export const GET_USER_DETAIL = "GET_USER_DETAIL"
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS"
export const GET_USER_DETAIL_FAIL = "GET_USER_DETAIL_FAIL"

/**
 * ADD USER
 */
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

/**
 * EDIT USER
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Delete user
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const CLEAR_STRIPE_ERROR = "CLEAR_STRIPE_ERROR"
export const RESET_DATA = "RESET_DATA"

/**
 * EDIT USER APPROVED SEASON CHANGES
 */
export const UPDATE_SEASON_CHANGE_STATUS = "UPDATE_SEASON_CHANGE_STATUS"
export const UPDATE_SEASON_CHANGE_STATUS_SUCCESS =
  "UPDATE_SEASON_CHANGE_STATUS_SUCCESS"
export const UPDATE_SEASON_CHANGE_STATUS_FAIL =
  "UPDATE_SEASON_CHANGE_STATUS_FAIL"

/**
 * Backlist user
 */
export const BLACKLIST_USER = "BLACKLIST_USER"
export const BLACKLIST_USER_SUCCESS = "BLACKLIST_USER_SUCCESS"
export const BLACKLIST_USER_FAIL = "BLACKLIST_USER_FAIL"

export const GET_UNAPPROVE_COUNT = "GET_UNAPPROVE_COUNT"
export const GET_UNAPPROVE_COUNT_SUCCESS = "GET_UNAPPROVE_COUNT_SUCCESS"
export const GET_UNAPPROVE_COUNT_FAIL = "GET_UNAPPROVE_COUNT_FAIL"

/**
 * Export Users for PMS
 */
export const GET_EXPORT_USERS = "GET_EXPORT_USERS"
export const GET_EXPORT_USERS_SUCCESS = "GET_EXPORT_USERS_SUCCESS"
export const GET_EXPORTED_USERS_FAIL = "GET_EXPORTED_USERS_FAIL"
export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA"

/* Charge User */
export const CHARGE_USER = "CHARGE_USER"
export const CHARGE_USER_SUCCESS = "CHARGE_USER_SUCCESS"
export const CHARGE_USER_FAIL = "CHARGE_USER_FAIL"

/* price bill */
export const GET_BILL_PRICE = "GET_BILL_PRICE"
export const GET_BILL_PRICE_SUCCESS = "GET_BILL_PRICE_SUCCESS"
export const GET_BILL_PRICE_FAIL = "GET_BILL_PRICE_FAIL"

/* Change Season USERS */
export const GET_CHANGESEASON_USERS = "GET_CHANGESEASON_USERS"
export const GET_CHANGESEASON_USERS_SUCCESS = "GET_CHANGESEASON_USERS_SUCCESS"
export const GET_CHANGESEASON_USERS_FAIL = "GET_CHANGESEASON_USERS_FAIL"
